import { Button, Col, Row, Table } from "antd";
import styles from "./styles.module.scss";
import { UseApiCallV2 } from "hooks";
import { UseLazyApiCallV2 } from "hooks/use-lazy-api-call-v2";
import { useState } from "react";
import { ConditionalRenderer } from "components/conditonal-renderer";
export function Testing({ fileId }: any) {
  // const [verificationData, setVerificationData] = useState<any>();
  // const [validationData, setValidationData] = useState<any>();
  const [operationalData, setOperationalDataData] = useState<any>();
  const [openTable, setOpenTable] = useState<string | null>(null); // State to track which table is open

  const {
    data: count,
    isLoading: countLoading,
    error: countDataError,
  } = UseApiCallV2({
    url: "/club_test_count",
    method: "POST",
    paramsData: {},
  });

  const { data: verificationData } = UseApiCallV2({
    url: "/club_test",
    method: "POST",
    paramsData: {
      mode: "verification",
      fileid: fileId,
    },
  }) as any;
  const { data: validationData } = UseApiCallV2({
    url: "/club_test",
    method: "POST",
    paramsData: {
      mode: "validation",
      fileid: fileId,
    },
  }) as any;

  const [testFunction, { isLoading }] = UseLazyApiCallV2({
    url: null,
    method: "POST",
  }) as any;

  // async function handleVerification() {
  //   if (openTable === "verification") {
  //     return setOpenTable(null);
  //   }
  //   if (verificationData) {
  //     setOpenTable("verification"); // Open the verification table if data already exists
  //     return;
  //   }

  //   setOpenTable("verification"); // Open the verification table

  //   try {
  //     const res = await testFunction({
  //       url: "/club_test",
  //       params: {
  //         mode: "verification",
  //         fileid: fileId,
  //       },
  //     });
  //     setVerificationData(res);
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // }

  // async function handleValidation() {
  //   if (openTable === "validation") {
  //     return setOpenTable(null);
  //   }
  //   if (validationData) {
  //     setOpenTable("validation"); // Open the verification table if data already exists
  //     return;
  //   }
  //   setOpenTable("validation"); // Open the validation table
  //   try {
  //     const res = await testFunction({
  //       url: "/club_test",
  //       params: {
  //         mode: "validation",
  //         fileid: fileId,
  //       },
  //     });
  //     setValidationData(res);
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // }

  async function handleOpertational() {
    try {
      await testFunction({
        url: "/club_test",
        params: {
          mode: "verification",
          fileid: fileId,
        },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const renderTableData = (data: any) => {
    if (!data) return null;

    return Object.entries(data).map(([key, value]: any) => ({
      test: value.Description,
      status: value.Status ? (
        <Button type="primary" disabled className={styles.passedButton}>
          Passed
        </Button>
      ) : (
        <Button type="primary" disabled className={styles.failedButton}>
          Failed
        </Button>
      ),
      description: value.Description,
    }));
  };

  const columns = [
    {
      title: "Test",
      dataIndex: "test",
      key: "test",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ];

  const cellStyle = {
    fontSize: "14px", // Adjust the font size as needed
  };
  return (
    <>
      <Row gutter={16} className={styles.testingRow}>
        <div>
          <div className={styles.testingContainer}>
            <div>
              <div
                className={`${styles.circleStyle} ${
                  operationalData
                    ? styles.circleStyleWithData
                    : styles.circleStyleWithOutData
                }`}
              >
                <div>
                  <p className={styles.internalHeading}>Opertaional</p>
                  <h2 className={styles.internalCount}>4</h2>
                </div>
              </div>
              {/* <div className={styles.buttonContainer}>
                <Button
                  className={styles.testBtn}
                  block={true}
                  type="primary"
                  onClick={handleOpertational}
                >
                  Test
                </Button>
              </div> */}
            </div>
            {operationalData && (
              <div className={styles.tableContainer}>
                <Table
                  dataSource={
                    renderTableData(operationalData.operations) as any
                  }
                  columns={columns.map((col) => ({
                    ...col,
                    onCell: () => ({
                      style: cellStyle, // Apply custom style to table cells
                    }),
                  }))}
                  pagination={false}
                />
              </div>
            )}
          </div>
        </div>{" "}
        {/* Second column */}
        <div>
          <div className={styles.testingContainer}>
            <div>
              <div
                className={`${styles.circleStyle} ${
                  verificationData
                    ? styles.circleStyleWithData
                    : styles.circleStyleWithOutData
                }`}
              >
                <div>
                  <p className={styles.internalHeading}>Verification</p>
                  <h2 className={styles.internalCount}>
                    {verificationData
                      ? verificationData?.verification_count
                      : count
                      ? (count as any)?.verification
                      : 0}
                  </h2>
                </div>
              </div>
              {/* <div className={styles.buttonContainer}>
                <Button
                  className={styles.testBtn}
                  block={true}
                  type="primary"
                  // onClick={handleVerification}
                >
                  {isLoading && openTable === "verification"
                    ? " Loading... "
                    : "Test"}
                </Button>
              </div> */}
            </div>
            {verificationData && (
              <div className={styles.tableContainer}>
                <Table
                  dataSource={
                    renderTableData(verificationData.verification) as any
                  }
                  columns={columns.map((col) => ({
                    ...col,
                    onCell: () => ({
                      style: cellStyle, // Apply custom style to table cells
                    }),
                  }))}
                  pagination={false}
                />
              </div>
            )}
          </div>
        </div>
        {/* Third column */}
        <div>
          <div className={styles.testingContainer}>
            <div>
              <div
                className={`${styles.circleStyle} ${
                  validationData
                    ? styles.circleStyleWithData
                    : styles.circleStyleWithOutData
                }`}
              >
                <div>
                  <p className={styles.internalHeading}>Validation</p>
                  <h2 className={styles.internalCount}>
                    {validationData
                      ? validationData?.validation_count
                      : count
                      ? (count as any)?.validation
                      : 0}
                  </h2>
                </div>
              </div>
              {/* <div className={styles.buttonContainer}>
                <Button
                  className={styles.testBtn}
                  block={true}
                  type="primary"
                  onClick={handleValidation}
                >
                  {isLoading && openTable === "validation"
                    ? " Loading... "
                    : "Test"}
                </Button>
              </div> */}
            </div>
            {validationData && (
              <div className={styles.tableContainer}>
                <Table
                  dataSource={renderTableData(validationData.validation) as any}
                  columns={columns.map((col) => ({
                    ...col,
                    onCell: () => ({
                      style: cellStyle, // Apply custom style to table cells
                    }),
                  }))}
                  pagination={false}
                />
              </div>
            )}
          </div>
        </div>
      </Row>
    </>
  );
}
